import Button from '@ui-kit/components/Button';
import { ModalActions } from '@ui-kit/components/Modal/Modal';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import type { ModalProps } from '@/components/ModalRenderer/components/types';
import { Modal } from '@/components/ModalRenderer/Modal';
import { type ProductName, ProductNames } from '@/constants/ProductNames';
import { QueryParams } from '@/constants/QueryParam';
import { routeMap } from '@/routes/routeMap';

type Payload = {
  depositAmount: number;
  productName: ProductName;
};
type Props = ModalProps<Payload>;

const redirectBaseMap: Record<ProductName, string> = {
  [ProductNames.CREDIT]: routeMap.credit.deposit.root,
  [ProductNames.DEBT_CONSOLIDATION]: routeMap.debtConsolidation.deposit,
  [ProductNames.LOAN]: routeMap.loan.deposit,
};

const DepositFail = ({ closeModal, payload }: Props) => {
  const { t } = useTranslation(['Modal', 'Button']);
  const navigate = useNavigate();
  const redirectBase = redirectBaseMap[payload.productName];
  const { depositAmount } = payload;

  return (
    <Modal title={t('DepositFail.title')}>
      <p>{t('DepositFail.info', { depositAmount })}</p>
      <ModalActions>
        <Button
          onClick={() => {
            void navigate(`${redirectBase}?${QueryParams.DEPOSIT_AMOUNT}=${depositAmount}`);
            closeModal();
          }}
        >
          {t('Button:clear')}
        </Button>
      </ModalActions>
    </Modal>
  );
};

export default DepositFail;
